const AboutUsRouter = [

  // Amazing team
  {
    path: '/about-us/amazing-team',
    name: 'ManageABoutUsAmazingTeam',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/AboutUs/ManageAmazingTeam.vue'),
    meta: {
      openSidebarKey: 'about-us',
      title: 'Quản lý amazing team '
    }
  },

  // Awards an archievements
  {
    path: '/about-us/awards-archievements',
    name: 'ManageAwardsArchievements',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/AboutUs/ManageAwards.vue'),
    meta: {
      openSidebarKey: 'about-us',
      title: 'Quản lý awards và archievements'
    }
  },
  {
    path: '/about-us/awards-archievements/create',
    name: 'CreateAwardsArchievements',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/AboutUs/ControllerAwards.vue'),
    meta: {
      openSidebarKey: 'about-us',
      title: 'Thêm mới awards và archievements'
    }
  },
  {
    path: '/about-us/awards-archievements/:id',
    name: 'UpdateAwardsArchievements',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/AboutUs/ControllerAwards.vue'),
    meta: {
      openSidebarKey: 'about-us',
      title: 'Cập nhật awards và archievements'
    }
  },

  // People in charge
  {
    path: '/about-us/people-in-charge',
    name: 'ManagePeopleInCharge',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/AboutUs/ManagePeopleInCharge.vue'),
    meta: {
      openSidebarKey: 'about-us',
      title: 'Quản lý people in charge'
    }
  },
  {
    path: '/about-us/people-in-charge/create',
    name: 'CreatePeopleInCharge',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/AboutUs/ControllerPeopleInCharge.vue'),
    meta: {
      openSidebarKey: 'about-us',
      title: 'Thêm mới people'
    }
  },
  {
    path: '/about-us/people-in-charge/:id',
    name: 'UpdatePeopleInCharge',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/AboutUs/ControllerPeopleInCharge.vue'),
    meta: {
      openSidebarKey: 'about-us',
      title: 'Cập nhật people'
    }
  },
]

export default AboutUsRouter;
